export const LOADING = 'contributerDashboard.LOADING';
export const LOAD_DATA = 'contributerDashboard.LOAD_DATA';
